import { useState, useMemo } from 'react'
import { FaTruck } from 'react-icons/fa'
import { FiInbox } from 'react-icons/fi'

import Input from '../../../shared/components/form/input'
import FormLayout from '../../../shared/components/FormLayout/FormLayout'

import './SelectProviderModal.css'

function SelectProviderModal({ providers, handleOnContinue }) {
    const [search, setSearch] = useState('')

    const filteredProviders = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return providers.filter((p) => !search || p.name.toLowerCase().includes(searchLowerCase))
    }, [providers, search])

    return (
        <FormLayout title="Cadastrar no Catálogo">
            <p className="spm-hint"><span className="spm-hint-star">*</span> Escolha o fornecedor clicando em um dos cards</p>

            <div className="spm-search">
                <Input
                    type="text"
                    name="search"
                    placeholder="Buscar fornecedor..."
                    value={search}
                    handleOnChange={(e) => setSearch(e.target.value)}
                />
            </div>

            {filteredProviders.length > 0 ? (
                <div className="spm-grid">
                    {filteredProviders.map((p) => (
                        <div key={p._id} className="spm-card" onClick={() => handleOnContinue(p)}>
                            <div className="spm-card-icon"><FaTruck size={18} /></div>
                            <span className="spm-card-name">{p.name}</span>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="pg-empty">
                    <FiInbox size={28} className="pg-empty-icon" />
                    <p className="pg-empty-title">Nenhum fornecedor encontrado</p>
                </div>
            )}
        </FormLayout>
    )
}

export default SelectProviderModal
